import Joi from 'joi';

import { createTenantBillingSchema } from '../../../billing/validators/schemas/create-tenant-billing.schema';
import { createTenantContactSchema } from '../../../contacts/validators/schemas/create-tenant-contact.schema';

/**
 * Schema for new tenant record validation.
 */
export const createTenantSchema = () =>
  Joi.object({
    email: Joi.string().email().required(),
    // Contact
    contact: createTenantContactSchema(),
    billing: createTenantBillingSchema().optional(),
  })
    // Ignore extra fields
    .unknown();
